import { CheckboxField, type CheckboxFieldProps } from '@sunwebgroup/uds-ui/fields/checkbox-field'
import { Typography } from '@sunwebgroup/uds-ui/typography'

import get from 'lodash/get'
import { Controller, FieldError, type RegisterOptions, useFormContext } from 'react-hook-form'
import styles from './CheckboxInput.module.css'

export interface CheckboxGroupInputProps extends CheckboxFieldProps {
  name: string
  value?: string
  validationMessage?: string
  rules?: RegisterOptions
  hideErrorMessage?: boolean
}

export function CheckboxGroupInput({
  name,
  value,
  validationMessage,
  rules,
  hideErrorMessage = false,
  ...restProps
}: CheckboxGroupInputProps) {
  const {
    control,
    formState,
  } = useFormContext()
  const { errors } = formState
  const fieldError = get(errors, name) as FieldError | undefined
  const errorMessage = fieldError?.message as string | undefined
  const hasError = !!fieldError

  return (
    <div className={styles.formCheckboxContainer}>
      <Controller
        name={name}
        control={control}
        rules={rules}
        render={({ field }) => {
          const fieldValues = field.value ?? []
          const isChecked = fieldValues.includes(value)

          return (
            <CheckboxField
              {...restProps}
              checked={isChecked}
              onCheckedChange={(checkedState) => {
                if (checkedState) {
                  field.onChange([...fieldValues, value])
                }
                else {
                  field.onChange(fieldValues.filter((val: string) => val !== value))
                }
              }}
              error={hasError}
              id={`${field.name}-${value || ''}`}
              variant="outlined"
            />
          )
        }}
      />
      {!hideErrorMessage && hasError && errorMessage && (
        <Typography as="p" variant="body-s-bold-snug" className={styles.errorMessage}>{errorMessage}</Typography>
      )}
    </div>
  )
}
